import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IElementTemplate } from 'elements/types';
import { Color, Variant } from 'theme/enums';

import { AddElementTemplateToJob } from './AddElementTemplateToJob';

interface IProps {
  elementTemplate: IElementTemplate;
  buttonElement?: ReactElement;
  disabled?: boolean;
}

export const AddElementTemplateToJobButton = ({
  elementTemplate,
  buttonElement,
  disabled,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const button = buttonElement ? (
    cloneElement(buttonElement, { onClick: () => setIsOpen(true) })
  ) : (
    <Button
      text={t('buttonLabelAddToJob')}
      variant={Variant.SOFT}
      color={Color.PRIMARY}
      startDecorator={<Plus />}
      onClick={() => setIsOpen(true)}
      disabled={disabled}
    />
  );

  return (
    <>
      {button}
      <AddElementTemplateToJob
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        elementTemplate={elementTemplate}
      />
    </>
  );
};
